import React from 'react';
import './IntroSection.css';

function IntroSection() {
  return (
    <div className="trading-intro-section">
      <div className="intro-container">
        {/* 히어로 섹션 */}
        <section className="intro-hero">
          <h1 className="hero-title">
            <span className="title-sub">AI주식거래서비스</span>
            <span className="title-main">제우스</span>
          </h1>
          <p className="hero-description">
            인공지능이 분석하고 추천하는 스마트한 주식 거래 플랫폼
          </p>
        </section>

        {/* 서비스 소개 */}
        <section className="intro-service">
          <h2 className="section-title">서비스 소개</h2>
          <div className="service-grid">
            <div className="service-card">
              <div className="card-icon">🤖</div>
              <h3 className="card-title">AI 기반 분석</h3>
              <p className="card-description">
                Google AI (Gemini)와 로컬 AI (Ollama)를 활용한 
                다중 AI 엔진으로 주식을 심층 분석합니다.
              </p>
            </div>
            <div className="service-card">
              <div className="card-icon">📊</div>
              <h3 className="card-title">실시간 시세 연동</h3>
              <p className="card-description">
                한국투자증권(KIS) API와 연동하여 
                실시간 시세와 거래를 제공합니다.
              </p>
            </div>
            <div className="service-card">
              <div className="card-icon">⚡</div>
              <h3 className="card-title">자동 거래</h3>
              <p className="card-description">
                AI 추천에 따른 자동 매수/매도와 
                예약 주문 기능을 지원합니다.
              </p>
            </div>
            <div className="service-card">
              <div className="card-icon">🛡️</div>
              <h3 className="card-title">모의투자 지원</h3>
              <p className="card-description">
                실전 투자 전 모의투자로 전략을 검증하고 
                안전하게 학습할 수 있습니다.
              </p>
            </div>
          </div>
        </section>

        {/* AI 기술 스택 */}
        <section className="intro-ai-tech">
          <h2 className="section-title">AI 기술 스택</h2>
          <div className="ai-tech-grid">
            <div className="ai-tech-card primary">
              <div className="tech-header">
                <span className="tech-icon">🌐</span>
                <h3 className="tech-title">Google AI (Gemini)</h3>
              </div>
              <ul className="tech-features">
                <li>최신 Gemini 모델 API</li>
                <li>웹 검색 통합 분석</li>
                <li>고급 추론 능력</li>
                <li>JSON 구조화 응답</li>
              </ul>
            </div>
            <div className="ai-tech-card secondary">
              <div className="tech-header">
                <span className="tech-icon">💻</span>
                <h3 className="tech-title">로컬 AI (Ollama)</h3>
              </div>
              <ul className="tech-features">
                <li>Qwen3:8b (메인 분석 모델)</li>
                <li>Llama3.2:3b (빠른 응답 모델)</li>
                <li>오프라인 분석 가능</li>
                <li>개인정보 보호 강화</li>
              </ul>
            </div>
            <div className="ai-tech-card fallback">
              <div className="tech-header">
                <span className="tech-icon">📈</span>
                <h3 className="tech-title">규칙 기반 분석</h3>
              </div>
              <ul className="tech-features">
                <li>RSI, MACD 기술적 지표</li>
                <li>볼린저 밴드 분석</li>
                <li>이동평균선 분석</li>
                <li>AI 실패 시 폴백</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 주요 기능 */}
        <section className="intro-features">
          <h2 className="section-title">주요 기능</h2>
          <div className="features-list">
            <div className="feature-item">
              <div className="feature-number">01</div>
              <div className="feature-content">
                <h3 className="feature-title">AI 종목 분석</h3>
                <p className="feature-description">
                  다중 AI 엔진이 종목의 기술적 지표, 재무 상태, 시장 동향을 종합 분석하여 
                  매수/매도/보유 추천과 신뢰도를 제공합니다.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">02</div>
              <div className="feature-content">
                <h3 className="feature-title">자동 거래 실행</h3>
                <p className="feature-description">
                  AI 추천 신뢰도가 임계값을 넘으면 자동으로 매수/매도 주문을 실행합니다. 
                  잔액 제한, 수량 비율 등 세밀한 설정이 가능합니다.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">03</div>
              <div className="feature-content">
                <h3 className="feature-title">포트폴리오 관리</h3>
                <p className="feature-description">
                  보유 종목 현황, 손익 분석, 성과 통계를 실시간으로 확인하고 
                  AI 추천에 따른 포트폴리오 최적화를 지원합니다.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">04</div>
              <div className="feature-content">
                <h3 className="feature-title">예약 주문</h3>
                <p className="feature-description">
                  특정 시간 또는 조건에 주문을 실행하는 예약 주문 기능으로 
                  시장 상황을 놓치지 않고 거래할 수 있습니다.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">05</div>
              <div className="feature-content">
                <h3 className="feature-title">투자 전략 설정</h3>
                <p className="feature-description">
                  7단계 투자 전략(단기-강/약, 중간-균형/강/약, 장기-강/약) 또는 
                  사용자 정의 전략으로 AI 분석 방식을 맞춤 설정할 수 있습니다.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-number">06</div>
              <div className="feature-content">
                <h3 className="feature-title">실시간 알림</h3>
                <p className="feature-description">
                  AI 분석 완료, 자동 거래 실행, 손실 발생 등 중요한 이벤트를 
                  이메일 또는 텔레그램으로 실시간 알림 받을 수 있습니다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 작동 방식 */}
        <section className="intro-workflow">
          <h2 className="section-title">작동 방식</h2>
          <div className="workflow-steps">
            <div className="workflow-step">
              <div className="step-icon">1</div>
              <h3 className="step-title">종목 선택</h3>
              <p className="step-description">
                관심 종목을 검색하고 즐겨찾기에 추가
              </p>
            </div>
            <div className="workflow-arrow">→</div>
            <div className="workflow-step">
              <div className="step-icon">2</div>
              <h3 className="step-title">AI 분석</h3>
              <p className="step-description">
                Google AI 또는 로컬 AI가 종목을 심층 분석
              </p>
            </div>
            <div className="workflow-arrow">→</div>
            <div className="workflow-step">
              <div className="step-icon">3</div>
              <h3 className="step-title">추천 생성</h3>
              <p className="step-description">
                매수/매도/보유 추천과 신뢰도 제공
              </p>
            </div>
            <div className="workflow-arrow">→</div>
            <div className="workflow-step">
              <div className="step-icon">4</div>
              <h3 className="step-title">자동 실행</h3>
              <p className="step-description">
                설정된 조건에 따라 자동으로 거래 실행
              </p>
            </div>
          </div>
        </section>

        {/* 특징 요약 */}
        <section className="intro-highlights">
          <h2 className="section-title">서비스 특징</h2>
          <div className="highlights-grid">
            <div className="highlight-item">
              <span className="highlight-badge">다중 AI</span>
              <p>Google AI와 로컬 AI를 동시 활용하여 정확도 향상</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-badge">실시간</span>
              <p>KIS API 연동으로 실시간 시세 및 거래 지원</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-badge">자동화</span>
              <p>AI 추천 기반 자동 매수/매도로 시간 절약</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-badge">안전성</span>
              <p>모의투자로 전략 검증 후 실전 투자 가능</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-badge">맞춤형</span>
              <p>7단계 투자 전략 및 사용자 정의 설정 지원</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-badge">투명성</span>
              <p>모든 분석 결과와 거래 내역을 상세히 기록</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default IntroSection;
